<template>
<div class="collabsable-section">
    <div class="section-title clickable-header" @click="toggleExpanded()">
        <div class="point-cloud"></div>
        <div style="flex-grow: 1;font-size: 17px;">Point Clouds</div>
        <div style="color: gray;" :class="['expand-collapse-ico','fas',!isExpanded?'fa-caret-down':'fa-caret-up']"></div>
    </div>
    <div v-if="isExpanded" class="expanded-section">
        <SelectionInfo :selected_items="selected_items" @delete-selection="deleteSelectedItems()" @clear-selection="onClearSelection"></SelectionInfo>
        <div v-for="item in pointclouds" :key="item.id" class="model-row" @click="item.isSelected = !item.isSelected;updateSelectedItems()">
            <input v-if="item.isOnlyURL" type="checkbox" v-model="item.isSelected" @change="updateSelectedItems()" />
            <b style="padding-left: 5px;flex-grow:1;">{{item.name}}</b><br />
            <div v-if="item.isOnlyURL" class="linked-pointcloud">Linked</div>
            <div class="btn-hover-orange fas fa-edit" @click.stop="editPointCloudUrl(item)"></div>
            <div class="btn-hover-orange fas fa-trash" @click.stop="onPointCloudDeleting(item)"></div>
        </div>
        <div class="info-section" style="align-items: center;">
            <input type="file" webkitdirectory multiple style="display: none;" id="browsePointCloudFile" @change="onPointCloudFileChanged($event)">
            <progress style="width: 50%;height: 20px;" v-if="isUploadingPointCloud" min="0" :max="maxProgress" step="1" :value="progress"></progress>
            <div v-if="isUploadingPointCloud">{{progress}}/{{maxProgress}} Files {{isDeleting?'Deleted':'Uploaded'}}</div>
            <div style="display: flex;width: 100%;justify-content: center;">
                <div class="admin-btn" style="margin-right: 7px;width:200px;" @click="AddPointCloudFolder()">Add Synology Folder</div>
                <div class="admin-btn" style="margin-right: 7px;w" @click="AddPointCloudURL()">Add URL</div>
                <div class="admin-btn" style="margin-right: 7px;" @click="clickOnUploadPointCloud()">Upload</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { postDataAsync } from '../../../utils/mongoUtils'
import { toggleExpandComponent } from '../../../scripts/js/forgeviewer'
import { PointCloudModelInfo } from '../../../scripts/js/forgeModels'
import SelectionInfo from '@/components/common/selectionInfo.vue'
export default {
    name: 'AdminPointClouds',
    components: {
        SelectionInfo
    },
    props: ['pointclouds', 'assetid'],
    data() {
        return {
            isExpanded: false,
            isUploadingPointCloud: false,
            progress: 0,
            maxProgress: 100,
            isDeleting: false,
            selected_items: this.pointclouds.filter(o => o.isSelected)
        }
    },
    methods: {
        onClearSelection() {
            this.pointclouds.forEach(o => o.isSelected = false);
            this.updateSelectedItems();
        },
        deleteSelectedItems() {
            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to delete selected pointcloud/s?',
                callback: () => {
                    let ids = this.selected_items.map(o => o.id)
                    this.$store.state.forgeService.deletePointClouds(ids)
                    for (var i = 0; i < this.selected_items.length; i++) {
                        var index = this.pointclouds.findIndex(o => o.id == this.selected_items[i].id);
                        let newPcs = this.pointclouds.slice(0, index).concat(this.pointclouds.slice(index + 1));
                        this.$emit('update_pointclouds', newPcs);
                    }
                    this.selected_items = []
                }
            })

        },
        updateSelectedItems() {
            this.selected_items = this.pointclouds.filter(o => o.isSelected);
        },
        onPointCloudFileChanged(event) {
            if (event.target.files.length == 0)
                return;

            this.$store.dispatch({
                type: "prompt_Forge",
                title: "Add PointCloud Name",
                callback: pointCloudName => {

                    if (!pointCloudName) {
                        (document.getElementById("browsePointCloudFile")).value = '';
                        return;
                    }
                    this.isDeleting = false;
                    this.isUploadingPointCloud = true;
                    this.maxProgress = event.target.files.length;
                    this.progress = 0;

                    var onProgress = () => {
                        this.progress++;
                        if (this.progress == this.maxProgress) {
                            console.log('Uploading Done.');
                            (document.getElementById("browsePointCloudFile")).value = '';
                            this.isUploadingPointCloud = false;
                            this.$store.dispatch({type: 'showSuccessfulMessage',message: "Uploaded successfully...", timeout: 2000})
                        }
                    };
                    var onCloudJsFileUploaded = (pointCloudModel) => {
                        console.log(pointCloudModel);
                        if (!this.pointclouds)
                            this.$emit('update_pointclouds', []);

                        this.$emit('update_pointclouds', this.pointclouds.concat(pointCloudModel));
                    };
                    this.forgeService.uploadPointCloud(event.target.files, pointCloudName, this.assetid, onProgress, onCloudJsFileUploaded);
                },
                input: {
                    inputName: "Name",
                    inputValue: ""
                }
            })
        },
        onPointCloudDeleting(pcModel) {
            if (this.isUploadingPointCloud) {
                this.$store.dispatch({
                    type: "alert_Forge",
                    message: 'Cannot delete while uploading.'
                })
                return;
            }

            this.$store.dispatch({
                type: "confirm_Forge",
                message: 'Are you sure you want to delete point cloud?',
                callback: () => {
                    this.isDeleting = true;
                    this.isUploadingPointCloud = true;
                    this.progress = 0;
                    var _this = this;
                    var onProgress = (progress, maxProgress) => {
                        _this.progress = progress;
                        _this.maxProgress = maxProgress;
                    };
                    var onDone = () => {
                        _this.isUploadingPointCloud = false;
                        let index = this.pointclouds.findIndex(o => o == pcModel);
                        let newPcs = this.pointclouds.slice(0, index).concat(this.pointclouds.slice(index + 1));
                        this.$emit('update_pointclouds', newPcs);
                        this.$store.dispatch({type: 'showSuccessfulMessage',message: "Point Cloud deleted successfully.", timeout: 2000})
                    };
                    if (pcModel.isOnlyURL) {
                        this.forgeService.deletePointCloud_Mongo(pcModel.id, () => {
                            onDone();
                        });
                    } else
                        this.forgeService.deletePointCloud(pcModel, onProgress, onDone);
                }
            })
        },
        clickOnUploadPointCloud() {
            document.getElementById("browsePointCloudFile").click();
        },
        editPointCloudUrl(item) {
            this.$store.dispatch({
                type: "prompt_Forge",
                title: 'Edit Point Cloud Name',
                callback: name => {
                    if (!name || !name.trim())
                        return;
                    item.name = name;

                    //TODO: edit if url only
                    if (item.isOnlyURL) {
                        this.$store.dispatch({
                            type: "prompt_Forge",
                            title: 'Edit Point Cloud URL',
                            callback: url => {
                                if (!url || !url.trim())
                                    return;
                                item.url = url;
                                postDataAsync('api/forge/pointClouds/editPointCloud', item)
                            },
                            input: {
                                inputName: "URL",
                                inputValue: item.url
                            }
                        })
                    } else
                        postDataAsync('api/forge/pointClouds/editPointCloud', item)
                },
                input: {
                    inputName: "Name",
                    inputValue: item.name
                }
            })
        },
        AddPointCloudURL() {
            this.$store.dispatch({
                type: "prompt_Forge",
                title: 'Add Point Cloud File Url (cloud.js OR metadata.json)',
                callback: url => {
                    if (!url || !url.trim())
                        return;

                    this.$store.dispatch({
                        type: "prompt_Forge",
                        title: 'Add Point Cloud Name',
                        callback: name => {
                            if (!name.trim())
                                return;
                            this.forgeService.addPointCloudUrlToMongo(this.assetid, name, url, (pointCloud) => {
                                if (!this.pointclouds) this.$emit('update_pointclouds', [])
                                pointCloud = Object.assign(new PointCloudModelInfo(), pointCloud);
                                this.$emit('update_pointclouds', this.pointclouds.concat(pointCloud));
                            });
                        },
                        input: {
                            inputName: "Name",
                            inputValue: ""
                        }
                    })
                },
                input: {
                    inputName: "Url",
                    inputValue: ""
                }
            })
        },
        AddPointCloudFolder() {
            this.$store.dispatch({
                type: "prompt_Forge",
                title: 'Add Synology folder of point clouds',
                callback: url => {
                    if (!url || !url.trim())
                        return;
                    if (!url.startsWith('/Reality/web')) {
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: 'Folder has to start with "/Reality/web".'
                        })
                        return;
                    }

                    this.forgeService.addPointCloudFolder(this.assetid, url, (pointClouds) => {
                        if (!this.pointclouds) this.$emit('update_pointclouds', [])
                        
                        pointClouds = pointClouds.map(o => Object.assign(new PointCloudModelInfo(), o));
                        let existingPointClouds = this.pointclouds.map(o=>o.url)
                        pointClouds = pointClouds.filter(o=>!existingPointClouds.includes(o.url))
                        if(pointClouds.length == 0){
                            this.$store.dispatch({type: "alert_Forge",message: 'No new point clouds found.'})
                            return;
                        }

                        this.$emit('update_pointclouds', this.pointclouds.concat(pointClouds));
                        this.forgeService.sortByName(this.pointclouds);
                    });
                },
                input: {
                    inputName: "Folder Url (/Reality/web)",
                    inputValue: ""
                }
            })
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        }
    },
    computed: {
        forgeService() {
            return this.$store.state.forgeService;
        }
    }
}
</script>

<style>
.point-cloud {
    background-size: cover;
    background-image: url(../../../images/pointCloud-black.png);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}

.linked-pointcloud {
    font-size: 12px;
    text-decoration: underline;
    color: darkblue;
}
</style>
